import type { Locale } from "@/lib/i18n/config";
import { SellersPage } from "./SellersPage";

/**
 * `restaurants/new` (linked from the restaurants list): the "Add restaurant"
 * drawer — for a new seller or an existing one — over the sellers list.
 * Closing it goes back to the restaurants list it was opened from.
 */
export function RestaurantCreatePage({ locale }: { locale: Locale }) {
  return <SellersPage locale={locale} limit={20} offset={0} create="restaurant" />;
}
